<template>
  <svg :width="width" :height="height" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M44.6179 4.02844C44.6179 3.46045 45.0784 3 45.6463 3C55.3898 3 63.3574 10.9691 63.3574 20.7135C63.3574 30.4566 55.3897 38.4257 45.6463 38.4257H33.18C23.4976 38.4257 15.5681 30.558 15.4675 20.8994C15.4565 20.8391 15.4507 20.777 15.4507 20.7135C15.4507 20.1455 15.9112 19.685 16.4792 19.685H44.6179V4.02844ZM17.5571 21.7419H45.6463C46.2143 21.7419 46.6748 21.2814 46.6748 20.7135V5.09058C54.8078 5.62512 61.3005 12.4503 61.3005 20.7135C61.3005 29.3209 54.2536 36.3688 45.6463 36.3688H33.18C24.9169 36.3688 18.0917 29.8751 17.5571 21.7419Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.30122 8.53511C4.70285 8.13349 5.35402 8.13349 5.75565 8.53511L17.2068 19.9863C17.6085 20.3879 17.6085 21.0391 17.2068 21.4407C16.8052 21.8424 16.154 21.8424 15.7524 21.4407L4.30122 9.98954C3.89959 9.58791 3.89959 8.93674 4.30122 8.53511Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.7697 36.2286C29.1713 35.8269 29.8225 35.8269 30.2241 36.2286L47.9539 53.9583C48.3555 54.36 48.3555 55.0111 47.9539 55.4128C47.5522 55.8144 46.9011 55.8144 46.4994 55.4128L28.7697 37.683C28.368 37.2814 28.368 36.6302 28.7697 36.2286Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M53.1383 52.3634C50.2169 52.3634 47.8485 54.731 47.8485 57.6533C47.8485 60.5745 50.2171 62.9431 53.1383 62.9431C56.0595 62.9431 58.4281 60.5745 58.4281 57.6533C58.4281 54.731 56.0597 52.3634 53.1383 52.3634ZM45.7916 57.6533C45.7916 53.5947 49.0812 50.3066 53.1383 50.3066C57.1954 50.3066 60.485 53.5947 60.485 57.6533C60.485 61.7105 57.1955 65 53.1383 65C49.0811 65 45.7916 61.7105 45.7916 57.6533Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M50.5314 36.0706C50.9331 36.4722 50.9331 37.1234 50.5314 37.525L34.1492 53.9073C33.7475 54.309 33.0964 54.309 32.6947 53.9073C32.2931 53.5057 32.2931 52.8545 32.6947 52.4529L49.077 36.0706C49.4786 35.669 50.1298 35.669 50.5314 36.0706Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M27.8114 52.3634C24.8901 52.3634 22.5216 54.731 22.5216 57.6533C22.5216 60.5745 24.8902 62.9431 27.8114 62.9431C30.7326 62.9431 33.1013 60.5745 33.1013 57.6533C33.1013 54.731 30.7328 52.3634 27.8114 52.3634ZM20.4647 57.6533C20.4647 53.5947 23.7543 50.3066 27.8114 50.3066C31.8685 50.3066 35.1581 53.5947 35.1581 57.6533C35.1581 61.7105 31.8686 65 27.8114 65C23.7542 65 20.4647 61.7105 20.4647 57.6533Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M53.1387 55.29C54.4444 55.29 55.5021 56.3477 55.5021 57.6534C55.5021 58.9579 54.4444 60.0156 53.1387 60.0156C51.8342 60.0156 50.7765 58.9579 50.7765 57.6534C50.7765 56.3477 51.8342 55.29 53.1387 55.29Z"
      fill="#FF0064"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M27.8095 55.29C29.1152 55.29 30.1729 56.3477 30.1729 57.6534C30.1729 58.9579 29.1152 60.0156 27.8095 60.0156C26.505 60.0156 25.4473 58.9579 25.4473 57.6534C25.4473 56.3477 26.505 55.29 27.8095 55.29Z"
      fill="#FF0064"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'NannyIllustration',
  props: {
    width: {
      type: Number,
      default: 68,
    },
    height: {
      type: Number,
      default: 68,
    },
  },
};
</script>
